import { Box, SxProps, Theme } from '@mui/material';
import React, { FC } from 'react';

type Props = { sx?: SxProps<Theme> };
const Logo: FC<Props> = ({ sx = {} }) => {
  return (
    <Box component="img" alt="Logo" src="/logo.png" loading="eager" sx={sx} />
  );
};

export default Logo;
